export default __webpack_public_path__ + "static/media/logo_licenciamento.856e5eb8.png";